import { useTranslation } from 'react-i18next';
import * as S from './styles';

// 로딩 캐릭터 이미지
import sunBg from './assets/loading-sun-bg.png';
import faceOpen from './assets/loading-face-open.png';
import faceClosed from './assets/loading-face-closed.png';
import ButtonLoadingDots from '../Common/ButtonLoadingDots';

const LoadingFallback: React.FC<{ text?: string }> = ({ text }) => {
  const { t, i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  return (
    <S.Container>
      <S.CharacterWrapper>
        <S.SunBackground src={sunBg} alt="" />
        <S.FaceClosed src={faceClosed} alt="" />
        <S.FaceOpen src={faceOpen} alt="" />
      </S.CharacterWrapper>

      <S.LoadingText>
        {text ? (
          <>
            {t(text)}
            <ButtonLoadingDots style={{ position: 'relative', top: '2px' }} />
          </>
        ) : (
          <>
            <p>{isKo ? '잠시만 기다려주세요' : 'Piecrip is getting'}</p>
            <p>{isKo ? '준비중입니다' : 'things ready'}</p>
          </>
        )}
      </S.LoadingText>
    </S.Container>
  );
};

export default LoadingFallback;
